import { initSubRoutes } from '../../../../utils/router';

const RoutesSignalerErreur = initSubRoutes({
    route: '/signaler-erreur/:uuidArme',
    subroutes: {},
    nom: 'Arme signaler une erreur',
});

export default RoutesSignalerErreur;
